
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/termsofservice",
      function () {
        return require("private-next-pages/termsofservice.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/termsofservice"])
      });
    }
  